import useSWR from 'swr';
import apiClient from '../../utils/axiosConfig';

const fetcher = url => apiClient.get(url).then(res => res.data);

export const useHomeData = () => {
    const { data, error } = useSWR(`/get-statistics`, fetcher, { revalidateOnFocus: false });
    const homeData = data?.data
    const getObject = (object) => {
        const newObject = {
            amount: object?.amount,
            transaction_id: object?.transaction_id,
            bank_transaction_id: object?.bank_transaction_id,
            rrn: object?.rrn,
            created_at: object?.created_at,
            status_name: object?.status_name,
            payment_method_name: object?.payment_method_name,
            powerbank_sn: object?.order?.powerbank_sn,
            rental_type_name: object?.order?.rental_type_name,
            rental_servicepoint_number: object?.order?.rental_servicepoint_number,
            return_servicepoint_number: object?.order?.return_servicepoint_number,
            rental_cabinet_sn: object?.order?.rental_cabinet_sn,
            start_time: object?.order?.start_time,
            end_time: object?.order?.end_time,
            order_amount: object?.order?.amount,
            rental_type: object?.order?.rental_type,
            status: object?.order?.status_name
        }
        return newObject;
    }
    return {
        getObject,
        homeData,
        isLoading: !error && !data,
        isError: error,
    };
};
